
        var result = require("!!../../../../node_modules/css-loader/index.js!./search.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/contract.awards/search.component.css
// module id = 1204
// module chunks = 0